import script from "./Projectpage.vue?vue&type=script&setup=true&lang=js"
export * from "./Projectpage.vue?vue&type=script&setup=true&lang=js"

import "./Projectpage.vue?vue&type=style&index=0&id=9b615ab6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b615ab6"]])

export default __exports__